import React from "react";
import Slider from "react-slick";

const desktopImages = [
  "/images/slider2.png",
  "/images/slider3.png", // Diğer masaüstü resimlerini de buraya ekleyebilirsin
];

const mobileImages = [
  "/images/9.webp",
];

const HeroSlider = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 1800,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
    fade: true,
  };

  return (
    <div className="relative w-full overflow-hidden m-0 p-0 h-[100vh] md:h-[90vh] bg-gray-100">
      
      {/* 1. SADECE MOBİL: Slider'ı tamamen devre dışı bırakıp tek bir düz resim basıyoruz. Masaüstü kodları buraya hiç uğramıyor */}
      <div className="block md:hidden w-full h-[100vh]">
        <img
          src={mobileImages[0]}
          alt="mobil-banner"
          width="430"
          height="932"
          fetchpriority="high"
          loading="eager"
          className="w-full h-full object-cover object-center"
        />
      </div>

      {/* 2. SADECE MASAÜSTÜ: Slider sadece masaüstü ekranlarda ayağa kalkıyor, mobil cihazlar bu slider yapısını ve içindeki resimleri yüklemiyor */}
      <div className="hidden md:block w-full h-[90vh]">
        <Slider {...settings}>
          {desktopImages.map((src, index) => (
            <div key={`desktop-${index}`}>
              <div className="relative w-full h-[90vh]">
                <img
                  src={src}
                  alt={`desktop-slide-${index}`}
                  width="1920"
                  height="1080"
                  fetchpriority={index === 0 ? "high" : "low"}
                  loading={index === 0 ? "eager" : "lazy"}
                  className="w-full h-full object-cover object-center"
                />
              </div>
            </div>
          ))}
        </Slider>
      </div>

    </div>
  );
};

export default HeroSlider;